import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles";

const CompleteStep = () => {
   const navigate = useNavigate();

   const handleGoToDashboard = () => {
       console.log("Go to Dashboard button clicked");

       const token = localStorage.getItem("token");
       console.log("Token in storage:", token);

       if (!token) {
           alert("No token found. Redirecting to login.");
           navigate("/login");
           return;
       }

       // Set `isLoggedIn` to sync with `authState` in AppRoutes
       localStorage.setItem("isLoggedIn", "true");
       console.log("isLoggedIn set to true in localStorage");

       console.log("Navigating to /dashboard");
       navigate("/dashboard");
   };

   React.useEffect(() => {
       console.log("CompleteStep component mounted");

       const token = localStorage.getItem("token");
       console.log("Token in localStorage on mount:", token);

       if (!token) {
           console.log("No token found on mount, redirecting to login.");
           navigate("/login");
       }
   }, [navigate]);

   return (
       <div style={styles.container}>
           <h2 style={styles.title}>You’re All Set!</h2>
           <p style={styles.text}>
               Your account is ready to go. Explore the dashboard to analyze your data, create cohorts, and view AI-driven insights.
           </p>
           <button onClick={handleGoToDashboard} style={styles.button}>
               Go to Dashboard
           </button>
       </div>
   );
};

export default CompleteStep;
